// Regola dinamica: blocca tutti i mesi precedenti al mese corrente.
// Esempio: dal 1° novembre, ottobre (e tutti i mesi prima) sono bloccati.
export const isCompetenzaLocked = (year: number, month: number) => {
  if (!year || !month) return false;
  const now = new Date();
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth() + 1; // 1-12
  if (year < nowYear) return true;
  if (year === nowYear && month < nowMonth) return true;
  return false;
};

export const LOCK_MESSAGE = 'Operazione non consentita: periodo bloccato (mesi precedenti al mese corrente)';
